module.exports = __webpack_public_path__ + "img/thomas.f9499b20.jpg";